export default __webpack_public_path__ + "static/media/wind.f17e832e.svg";